import { render, staticRenderFns } from "./Preferences.vue?vue&type=template&id=7b0684b1&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Preferences.vue"
export default component.exports